import { packageTypes } from 'json/detetion-options'
export let tableLabels = [{
  label: '套餐名称',
  value: 'name'
}, {
  label: '实验室检测平台',
  value: 'productBean.name'
}, {
  label: '检测项个数',
  value: 'detectionItemCount'
}, {
  label: '检测类型',
  value: 'package_type'
}, {
  label: '创建人',
  value: 'operationInformation.name'
}, {
  label: '创建时间',
  value: 'createdDate',
  minWidth: '120'
}]
// 套餐type枚举
export let packageType = packageTypes
// 检测平台枚举
export let filterLabels = [
  {
    label: '检测平台',
    type: 'select',
    value: 'sequencingTechnologyType', // 需返回数据的字段名
    options: [],
    clearable: true
  },
  {
    label: '检测类型',
    type: 'select',
    value: 'packageType', // 需返回数据的字段名
    options: packageTypes,
    clearable: true
  }
]
